module.exports = __webpack_public_path__ + "static/media/noLists.f70c2a78.png";